module.exports = __webpack_public_path__ + "static/media/vida_colectivo.13b4e6b6.svg";